import { render, staticRenderFns } from "./TraspasosSidebar.vue?vue&type=template&id=1dd57c23&"
import script from "./TraspasosSidebar.vue?vue&type=script&lang=js&"
export * from "./TraspasosSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports